const DefectsGOSTColumnsStructure = [
    {
        headerName: "Дефекты слева",
        field: "LeftDefectsStr",
        valueType: "float",
        align: "left",
    },
    {
        headerName: "Дефекты справа",
        field: "RightDefectsStr",
        valueType: "float",
        align: "left",
    },
]

const DefectsODMColumnsStructure = [
    {
        headerName: "Оценка в баллах",
        field: "Rating",
        valueType: "float",
        align: "center",
    }
]

export const DefectsAddColumnsStructure: any = {
    "DefectsGOST": DefectsGOSTColumnsStructure,
    "DefectsODM": DefectsODMColumnsStructure,
}